// Create cache outside the function (module-scoped)
let cachedSettings = null;

export function getSiteSetting(key, fallback = null) {
  try {
    // If no cache, read and parse from localStorage once
    if (!cachedSettings) {
      const raw = localStorage.getItem("siteSettings");
      cachedSettings = JSON.parse(raw);
    }

    if (cachedSettings && Object.prototype.hasOwnProperty.call(cachedSettings, key)) {
      return cachedSettings[key];
    }
  } catch (error) {
    console.warn("Failed to parse siteSettings:", error);
  }

  return fallback;
}
